module.exports = __webpack_public_path__ + "static/media/person-4.fdbbad26.jpg";